import { useState, useEffect } from "react";
import {
  fetchTasks,
  deleteTask,
  fetchDashBoardSummary,
} from "../services/taskService";
import { calculateStatus, sortTasks } from "../utils/taskStatus";

export const useTaskManagement = () => {
  const [allTasks, setAllTasks] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dashBoardSummary, setDashboardSummary] = useState();

  const refreshTasks = async () => {
    setIsLoading(true);
    try {
      const tasks = await fetchTasks();
      const dashBoardSummary = await fetchDashBoardSummary();
      setDashboardSummary(dashBoardSummary.singleData);
      setTasks(tasks);
      setAllTasks(tasks);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteTask = async (taskId) => {
    if (!window.confirm("Are you sure you want to delete this task?")) return;

    setIsLoading(true);
    try {
      await deleteTask(taskId);
      await refreshTasks();
      return true; // Success
    } catch (error) {
      console.error("Delete failed:", error);
      return false; // Failure
    } finally {
      setIsLoading(false);
    }
  };

  const isTaskDelayed = (task) => {
    const now = new Date();
    const dueDate = new Date(task.deadline);
    return !task.actualCompletionDate && dueDate < now;
  };

  const filterTask = (filterOption) => {
    console.log(filterOption);
    if (filterOption === "All") {
      setTasks(allTasks);
    } else {
      const filterTasks = allTasks.filter(
        (task) => task.priorityName === filterOption
      );
      console.log(filterTasks);
      setTasks(filterTasks);
    }
  };

  useEffect(() => {
    refreshTasks();
  }, []);

  return {
    tasks,
    setTasks,
    filterTask,
    dashBoardSummary,
    isLoading,
    refreshTasks,
    handleDeleteTask,
  };
};
